import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';
import { flex, centerItems } from 'scy/flex.mod.scss';
import { clickable } from 'scy/utils.mod.scss';
import ScreenReaderText from 'components/ScreenReaderText';

const RadioButton = ({
  containerClass,
  containerTag,
  inputClass,
  labelClass,
  btnClass,
  id,
  name,
  checked,
  onChange,
  disabled,
  checkedVariant,
  ariaLabel,
  ariaLabelText,
  children
}) => {
  const Tag = containerTag || 'div';

  return (
    <Tag className={containerClass}>
      <input
        type="radio"
        name={name}
        id={id}
        className={classnames(
          { [styles.checked]: checked },
          styles.input,
          inputClass
        )}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <label
        htmlFor={id}
        className={classnames(flex, clickable, centerItems, labelClass)}
      >
        <ScreenReaderText>{ariaLabelText}</ScreenReaderText>
        <div
          className={classnames(
            styles.circle,
            {
              [styles.checkedCircle]: checked,
              [styles.accentCheckedCircle]:
                checked && checkedVariant === 'accent',
              [styles.disabledCircle]: disabled
            },
            btnClass
          )}
        />
        {children}
      </label>
    </Tag>
  );
};

const AccentRadioButton = props => (
  <RadioButton checkedVariant="accent" {...props} />
);

export { RadioButton, AccentRadioButton };
